export default "__VITE_ASSET__hlWh5sZ5__"